import type { AttachmentSummary } from '@/entities/consignments';

import { RECEIVE_ATTACHMENT_SOURCE } from '../model/attachment-types';
import type { ReceiveAttachmentDto } from '../model/attachment-types';

/**
 * Receive attachment → the shape the shared attachment row renders.
 *
 * The two differ in exactly two places: a receive attachment knows which
 * shipment it hangs off, and its comment may come back `null`. Both are dropped
 * here, so the identity that the download needs has to be kept by the caller.
 */
export const toAttachmentSummary = (attachment: ReceiveAttachmentDto): AttachmentSummary => ({
  id: attachment.id,
  fileName: attachment.fileName,
  contentType: attachment.contentType,
  fileSize: attachment.fileSize,
  attachmentType: attachment.attachmentType,
  comment: attachment.comment ?? undefined
});

/** Splits the context's documents into the upstream ones and those of earlier receipts. */
export const groupAttachmentsBySource = (attachments: ReceiveAttachmentDto[] = []) => ({
  shipment: attachments.filter((item) => item.source === RECEIVE_ATTACHMENT_SOURCE.SHIPMENT),
  receipt: attachments.filter((item) => item.source === RECEIVE_ATTACHMENT_SOURCE.RECEIPT)
});
